module.exports = __webpack_public_path__ + "img/no_data.9da489b3.jpg";